import COM from '../../utils/Site'

export default COM
